import React, { ReactNode } from 'react';
import { AlignLeftOutlined, PlayCircleOutlined, FunctionOutlined } from '@ant-design/icons';
import { Footer, Row, Button } from '../../../../styles/common';
import arrowSendContext from 'img/arrow-send-context.svg';
import { MESSAGES } from '../../utils/constants';

interface SubmitFooterProps {
  BackButton?: ReactNode;
  questionAnswer?: number;
  hasCommentedQuestion: boolean;
  hasVideoEmbed: boolean;
  hasFormula: boolean;
  onSubmit: () => void;
  onReadResolution: () => void;
  onWatchResolution: () => void;
  onShowFormula: () => void;
}

export const SubmitFooter: React.FC<SubmitFooterProps> = ({
  BackButton,
  questionAnswer,
  hasCommentedQuestion,
  hasVideoEmbed,
  hasFormula,
  onSubmit,
  onReadResolution,
  onWatchResolution,
  onShowFormula,
}) => {
  return (
    <Footer>
      <Row width="100%" maxWidthTransformCol="1040px">
        {BackButton && <Row maxWidthTransformCol="1040px">{BackButton}</Row>}
        <Row maxWidthTransformCol="1040px">
          {hasCommentedQuestion && (
            <Button
              styles="secondary"
              onClick={onReadResolution}
              margin="0 0 0 16px"
              maxWidthTransformCol="1040px"
            >
              <AlignLeftOutlined /> {MESSAGES.READ_RESOLUTION}
            </Button>
          )}
          {hasVideoEmbed && (
            <Button
              styles="secondary"
              onClick={onWatchResolution}
              margin="0 0 0 16px"
              maxWidthTransformCol="1040px"
            >
              <PlayCircleOutlined /> {MESSAGES.WATCH_RESOLUTION}
            </Button>
          )}
          {hasFormula && (
            <Button
              styles="secondary"
              onClick={onShowFormula}
              margin="0 0 0 16px"
              maxWidthTransformCol="1040px"
            >
              <FunctionOutlined /> Fórmula
            </Button>
          )}
        </Row>
        <Row maxWidthTransformCol="1040px">
          <Button
            styles="primary"
            onClick={onSubmit}
            disabled={questionAnswer === undefined}
            className="seeResult"
            maxWidthTransformCol="1040px"
          >
            {MESSAGES.SAVE_AND_SEE_RESULT}
            <img src={arrowSendContext} alt="Enviar" />
          </Button>
        </Row>
      </Row>
    </Footer>
  );
};
